<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  summary: { type: Object, required: true },
});

const { t } = useI18n();

const safePercent = value => {
  if (!props.summary.total || props.summary.total === 0) return 0;
  return Math.round((value / props.summary.total) * 100);
};

const funnelItems = computed(() => [
  {
    key: 'total',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.TOTAL'),
    value: props.summary.total,
    percentage: 100,
    color: 'bg-[#322F23] text-white',
    icon: 'i-lucide-users',
  },
  {
    key: 'sent',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.SENT'),
    value: props.summary.sent,
    percentage: safePercent(props.summary.sent),
    color: 'bg-[#322F23] text-white',
    icon: 'i-lucide-check',
    iconColor: '',
  },
  {
    key: 'delivered',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.DELIVERED'),
    value: props.summary.delivered,
    percentage: safePercent(props.summary.delivered),
    color: 'bg-[#322F23] text-white',
    icon: 'i-lucide-check-check',
    iconColor: '',
  },
  {
    key: 'read',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.READ'),
    value: props.summary.read,
    percentage: safePercent(props.summary.read),
    color: 'bg-[#322F23] text-white',
    icon: 'i-lucide-check-check',
    iconColor: 'text-n-teal-9',
  },
  {
    key: 'clicked',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.CLICKED'),
    value: props.summary.clicked,
    percentage: safePercent(props.summary.clicked),
    color: 'bg-[#322F23] text-white',
    icon: 'i-lucide-mouse-pointer-click',
  },
  {
    key: 'replied',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.REPLIED'),
    value: props.summary.replied,
    percentage: safePercent(props.summary.replied),
    color: 'bg-[#322F23] text-white',
    icon: 'i-lucide-reply',
  },
  {
    key: 'failed',
    label: t('CAMPAIGN.WHATSAPP.ANALYTICS.FUNNEL.FAILED'),
    value: props.summary.failed,
    percentage: safePercent(props.summary.failed),
    color: 'bg-n-ruby-9 text-white',
    icon: 'i-lucide-x-circle',
  },
]);
</script>

<template>
  <div class="flex items-stretch gap-2">
    <div
      v-for="item in funnelItems"
      :key="item.key"
      class="flex-1 flex flex-col items-center gap-1 p-3 rounded-lg"
      :class="item.color"
    >
      <span
        class="size-4"
        :class="[item.icon, item.iconColor || 'opacity-80']"
      />
      <span class="text-xl font-semibold">{{ item.value }}</span>
      <span class="text-[10px] font-medium uppercase tracking-wide opacity-80">
        {{ item.label }}
      </span>
      <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
      <span class="text-xs opacity-70">{{ item.percentage }}%</span>
    </div>
  </div>
</template>
